export enum StorefrontWidgetPriceLocation {
  None = "none",
  Title = "title",
  Right = "right",
}
